/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Code_LabelInputs */

const en_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation Code`)
};

const fr_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code d'Activation`)
};

const de_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungscode`)
};

const it_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di attivazione`)
};

const ru_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код активации`)
};

const es_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de activación`)
};

const zh_cn2_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活码`)
};

const ja_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーションコード`)
};

const hi_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्टिवेशन कोड`)
};

const pt_pt2_login_offline_activation_code_label = /** @type {(inputs: Login_Offline_Activation_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de ativação`)
};

/**
* | output |
* | --- |
* | "Activation Code" |
*
* @param {Login_Offline_Activation_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_code_label = /** @type {((inputs?: Login_Offline_Activation_Code_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Code_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_code_label(inputs)
	if (locale === "de") return de_login_offline_activation_code_label(inputs)
	if (locale === "it") return it_login_offline_activation_code_label(inputs)
	if (locale === "ru") return ru_login_offline_activation_code_label(inputs)
	if (locale === "es") return es_login_offline_activation_code_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_code_label(inputs)
	if (locale === "ja") return ja_login_offline_activation_code_label(inputs)
	if (locale === "hi") return hi_login_offline_activation_code_label(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_code_label(inputs)
	return en_login_offline_activation_code_label(inputs)
});